import { Component, OnInit, ElementRef } from '@angular/core';
import { UserProfileService } from '../core/userProfile.service';
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { TableauService } from "../core/tableau.service";
import { Router } from '@angular/router';
import { StixConfigService } from '../shared/services/stixConfig.service';


@Component({
  selector: 'app-tableau',
  templateUrl: './tableau.component.html',
  styleUrls: ['./tableau.component.css']
})
export class TableauComponent implements OnInit {

  viz: any;
  public searchItem: string;
  public image: any;
  public workbookName: string;
  public allWorkBooks: any;
  public modifiedAllWorkBooks = [];
  public isSelected: string;
  public selectedWorkBookId: string;
  public selectedWorkBook: any;
  selected=0;
  public loaded = false;

  constructor(
    private userProfileService: UserProfileService,
    public dialog: MatDialog,
    private tableauService: TableauService,
    private router: Router,
    public elm: ElementRef,
    public stixConfig: StixConfigService
  ) { 
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  ngOnInit(): void {
    this.initTableau();
  }
  


  initTableau() {
    this.loadWorkBooks('');
  }   


  getWorkbooks() {
    this.loadWorkBooks(this.searchItem);
  }

  async loadWorkBooks(filter){
    this.loaded = false;
    this.allWorkBooks = await this.tableauService.loadWorkBooks(filter);
    this.loaded = true;
  }


  clickedCancel(){
    const navigationDetails: string[] = ['/'];
    this.router.navigate(navigationDetails);
  }

  select(workBookId){
    this.selectedWorkBookId = workBookId;
    this.allWorkBooks.filter(obj => {
      if (obj.workBookId === workBookId){
        this.selectedWorkBook = obj;
      }
    });
  }

  clickedWorkBook(){
    if (this.selectedWorkBookId !== "") {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: `Create Dashboard: ${this.selectedWorkBook.workbookName} `,
          message: `Are you sure you would like to select this workbook?`
        }
      });

      dialogRef.afterClosed().subscribe( async (confirmed) => {
        if (confirmed) {
            let contentUrl = '';
            let viewName = '';

            if ( !this.selectedWorkBook.customReportUrl ){
              if (this.selectedWorkBook.workbookViews.view[0].view && this.selectedWorkBook.workbookViews.view[0].view.contentUrl){
                contentUrl = this.selectedWorkBook.workbookViews.view[0].view.contentUrl.replace('/sheets','');
                viewName = this.selectedWorkBook.workbookViews.view[0].view.name;

              }
              else{
                contentUrl = this.selectedWorkBook.workbookViews.view[0].view[0].contentUrl.replace('/sheets',''); 
                viewName = this.selectedWorkBook.workbookViews.view[0].view[0].name
              }
            }
            await this.tableauService.setDashboard(this.userProfileService.userEmail, viewName, 
            this.selectedWorkBook.workbookName, this.selectedWorkBook.workBookId, this.selectedWorkBook.parentProject.name, this.userProfileService.userEmail, contentUrl, this.selectedWorkBook.customReportUrl);
            const navigationDetails: string[] = ['/'];
            this.router.navigate(navigationDetails);
        }     
      });
   }
  }


}